import styled from 'styled-components';
import { BLUE, ORANGE, GREEN, RED, BLACK } from 'root/theme';
import { MdErrorOutline, MdClose } from "react-icons/md";
import { media } from '@minerva-analytics/pantheon';

const alertColorMapping = {
  success: GREEN,
  warning: ORANGE,
  danger: RED,
  info: BLUE,
  error: RED,
};

const AlertsContainer = styled.div`
  margin: 0 auto;
  overflow: hidden;
  position: fixed;
  width: 100%;
  z-index: 10000;
  top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const QuizHiveAlert = styled.div`
  display: flex;
  flex-shrink: 0;
  position: relative;
  align-items: center;
  overflow: hidden;
  width: 90%;
  max-width: 972px;
  padding: 5px 10px;
  border-radius: 30px;
  box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  margin-bottom: 10px;
  transition: 0.5s;

  background: ${({ type }) => alertColorMapping[type]};
  opacity: ${({ state }) => (state === `entered` ? 1 : 0)};
  transform: translateY(${({ state }) => (state === `entered` ? 5 : 0)}px);
  color: white;

  p {
    width: 85%;
    margin: 0 auto;
    font-weight: 700;
    font-size: 1.1rem;
  }

  ${media.small`
    flex-direction: column;
    justify-content: flex-end;
    padding: 0px;
    p {
      margin: 10px auto;
      background: white;
      color: ${BLACK};
    }
  `}

`;

const MessageContainer = styled.div`
  width: 85%;
  ${media.small`
    margin-top: 52px;
    width: 100%;
    background: white;
  `}
`;

const CloseButton = styled(MdClose).attrs({
  fill: `white`,
})`
  font-size: 2.2rem;
  cursor: pointer;
  margin: 0 1rem 0 auto;

  ${media.small`
    position: absolute;
    right: 1rem;
    top: 0.5rem;
    margin: 0;
  `}
`;

const WarnIcon = styled(MdErrorOutline)`
  font-size: 2.2rem;
  ${media.small`
    position: absolute;
    left: 1rem;
    top: 0.5rem;
  `}
`;

export {
  AlertsContainer,
  QuizHiveAlert,
  WarnIcon,
  CloseButton,
  MessageContainer,
};
